/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxGet } from "../../funcs/sandboxGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSessionRequest$inboundSchema,
};

export const tool$sandboxGet: ToolDefinition<typeof args> = {
  name: "sandbox-get",
  description: `Get Session

Return the current state, configuration, and resource allocation for a sandbox session.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
